/* Claude speed loader — pairs with the head guard in claude-speed-head.liquid.
   Every deferred asset is restored; nothing is removed from the page. */
(function(){
  if(!('IntersectionObserver' in window))return;
  var RM={rootMargin:'900px 0px'};

  /* --- hero rotation clips 2..n: buffer them once the page has settled.
         Guarded so we never re-fetch a clip the rotation already started. --- */
  function warmHero(){
    var hv=document.querySelectorAll('video[data-vhero]');
    for(var i=0;i<hv.length;i++){
      var v=hv[i];
      v.setAttribute('preload','auto');
      if(v.readyState===0&&v.networkState!==2){
        try{v.load();}catch(e){}
      }
    }
  }
  if(document.readyState==='complete'){setTimeout(warmHero,1200);}
  else{window.addEventListener('load',function(){setTimeout(warmHero,1200);});}

  /* --- below-the-fold videos: load + autoplay when the visitor nears them --- */
  var vids=document.querySelectorAll('video[data-vdefer]');
  if(vids.length){
    var vo=new IntersectionObserver(function(es,o){
      for(var i=0;i<es.length;i++){
        if(!es[i].isIntersecting)continue;
        var v=es[i].target;o.unobserve(v);
        var s=v.getAttribute('data-src');
        if(s&&!v.getAttribute('src'))v.setAttribute('src',s);
        v.setAttribute('preload','auto');
        v.muted=true;
        if(v.readyState===0&&v.networkState!==2){try{v.load();}catch(e){}}
        if(v.getAttribute('data-autoplay')){
          var p=v.play();
          if(p&&p.catch)p.catch(function(){});
        }
      }
    },RM);
    for(var i=0;i<vids.length;i++)vo.observe(vids[i]);
  }

  /* --- TikTok embeds: restore the real class, then run TikTok's script --- */
  var tts=document.querySelectorAll('blockquote.tt-deferred');
  if(tts.length){
    var fired=false;
    var fire=function(){
      if(fired)return;fired=true;
      for(var i=0;i<tts.length;i++){
        tts[i].className=tts[i].className.replace('tt-deferred','tiktok-embed');
      }
      var s=document.createElement('script');
      s.async=true;
      s.src='https://www.tiktok.com/embed.js?cb='+Date.now();
      document.body.appendChild(s);
    };
    var to=new IntersectionObserver(function(es,o){
      for(var i=0;i<es.length;i++){
        if(es[i].isIntersecting){o.disconnect();fire();return;}
      }
    },RM);
    for(var j=0;j<tts.length;j++)to.observe(tts[j]);
  }
})();
